<template>
  <div class="counter">
    <div
      class="counter__info value_changed"
      v-if="valueChanged"
      v-html="valueChangeInfo"
      @click="disableInfo"
    />
    <div class="counter--content">
      <div
        class="counter__button counter__button--increase"
        :aria-label="$t('product.increase.button.label')"
        :class="{
          'counter__button--disabled': this.value === this.max
        }"
        @click.prevent="increase"
      />
      <div
        class="counter__button counter__button--decrease"
        :aria-label="$t('product.decrease.button.label')"
        :class="{
          'counter__button--disabled': this.value === this.min
        }"
        @click.prevent="decrease"
      />
      <input
        class="counter__input"
        :name="name"
        :aria-label="$t('product.input.field.label')"
        v-model="value"
        @change="changeValue"
        @keydown.enter.prevent="changeValue"
        @blur.prevent="blurHandler"
      >
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      initialValue: Number,
      step: {
        type: Number,
        default: 1
      },
      min: Number,
      max: Number,
      name: String,
      predefinedQuantities: Array,
      roundingMessage: {
        type: String,
        default: ""
      },
      nonValidInputMessage: {
        type: String,
        default: ""
      },
      graduatedPrices: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        value: 0,
        inputValue: 0,
        currentPredefinedQuantityIndex: null,
        minQuantity: this.min,
        maxQuantity: this.max,
        valueChanged: this.valueChanged,
        valueChangeInfo: this.valueChangeInfo
      }
    },
    mounted() {
      if (this.initialValue) {
        this.value = this.initialValue;
      }
      if (this.predefinedQuantities) {
        this.setPredefinedQuantityIndex();
      }
    },
    emits: ["change"],
    methods: {
      setPredefinedQuantityIndex() {
        let quantityIndex;
        this.minQuantity = this.predefinedQuantities[0];
        this.maxQuantity = this.predefinedQuantities[this.predefinedQuantities.length - 1];

        this.predefinedQuantities.map((quantity, index) => {
          if (quantity === this.initialValue) {
            quantityIndex = index;
          }
        });

        if (!quantityIndex) {
          quantityIndex = 0;
          this.value = this.predefinedQuantities[quantityIndex];
        }

        this.currentPredefinedQuantityIndex = quantityIndex;
      },
      increase() {
        if (this.predefinedQuantities) {
          if (this.currentPredefinedQuantityIndex + 1 <= this.predefinedQuantities.length - 1) {
            this.value = this.predefinedQuantities[this.currentPredefinedQuantityIndex + 1];
            this.$emit('change', this.value);
          }
        } else {
          if (this.max) {
            if (this.value % this.step > 0) {
              this.value = (Math.ceil((this.value) / this.step) * this.step);
            } else {
              this.value = this.value + this.step > this.max ? this.max : this.value + this.step;
            }
          } else {
            this.value = this.value + this.step;
          }
          this.$emit('change', this.value);
        }
      },
      decrease() {
        if (this.predefinedQuantities) {
          if (this.currentPredefinedQuantityIndex - 1 >= 0) {
            this.value = this.predefinedQuantities[this.currentPredefinedQuantityIndex - 1];
            this.$emit('change', this.value);
          }
        } else {
          if (this.min !== undefined) {
            if (this.value % this.step > 0) {
              this.value = (Math.ceil((this.value) / this.step) * this.step) - this.step;
            } else {
              this.value = this.value - this.step < this.min ? this.min : this.value - this.step;
            }
          } else {
            this.value = this.value - this.step;
          }

          this.$emit('change', this.value);
        }
      },
      changeValue() {
        this.inputValue = Number(this.value);
        if (this.step > 1 && !this.graduatedPrices && this.value < this.step) {
          this.value = this.value - this.step;
        }
        this.value = this.value !== '' ? this.value : (this.min ? this.min : 0);

        if (typeof this.value === 'string') {
          this.value = Number(this.value);
        }
        if (this.value % this.step > 0) {
          this.value = (Math.ceil((this.value) / this.step) * this.step);
          this.valueChanged = true;
          this.valueChangeInfo = this.roundingMessage;
        }
        if (this.value < this.min || isNaN(this.value)) {
          this.value = this.min;
          this.valueChanged = true;
          this.valueChangeInfo = this.nonValidInputMessage;
        }
        this.$emit('change', this.value);
      },
      blurHandler() {
        this.$emit('change', this.value);
      },
      getValue() {
        let value = Number(this.value);
        if (this.inputValue !== 0 && value < this.inputValue) {
          value += Number(this.step);
        }
        this.inputValue = 0;
        return value;
      },
      setValue(newValue) {
        this.value = parseInt(newValue);
      },
      disableInfo() {
        this.valueChanged = false;
      }
    }
  };

</script>
